import React, { useState, useEffect } from "react";

// AWS
import { API, Storage, Auth } from "aws-amplify";

function useGetPoint() {
  const [datas, setDatas] = useState([]);
  const [error, setError] = useState();
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = async (where = {}, options = { sortBy: "" }) => {
    try {
      setLoading(true);
      const datas = await API.get("MoneyHubAdmin", "/point", {
        queryStringParameters: {
          ...where,
        },
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`,
        },
      });
      const parseData = JSON.parse(datas.body);
      let newDatas = await Promise.all(
        parseData?.Items?.map(async (data) => {
          return {
            ...data,
          };
        })
      );

      if (options.sortBy) {
        newDatas = newDatas.sort((a, b) =>
          b[options.sortBy] > a[options.sortBy] ? 1 : -1
        );
      }
      setCount(datas.count);
      setDatas(newDatas);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
      console.log(error);
    }
  };

  return {
    datas,
    setDatas,
    count,
    error,
    setError,
    loading,
    setLoading,
    getData,
  };
}

export default useGetPoint;
